<template lang="pug">
section.home
    section.home__pesquisa-inteligente
        PesquisaInteligenteParaguay(
            v-if='this.usuarioLogado.ambienteLogado === this.ambientes.PARAGUAY'
        )
        PesquisaInteligenteArgentina(
            v-else-if='this.usuarioLogado.ambienteLogado === this.ambientes.ARGENTINA'
        )
        PesquisaInteligente(v-else)

    section.home__noticias
        BannerNoticias

    section.home__central-alertas
        CentralAlerta

    section.home__acesso-rapido
        AcessoRapido

    section.home__totalizadores
        Totalizadores

    section.home__central-eventos
        CentralEventos
</template>

<script>
import Totalizadores from '@/components/home/Totalizadores';
import CentralAlerta from '@/components/home/CentralAlerta';
import PesquisaInteligente from '@/components/home/PesquisaInteligente.vue';
import PesquisaInteligenteParaguay from '@/components/home/PesquisaInteligenteParaguay.vue';
import PesquisaInteligenteArgentina from '@/components/home/PesquisaInteligenteArgentina.vue';
import CentralEventos from '@/components/home/CentralEventos.vue';
import BannerNoticias from '@/components/home/BannerNoticias.vue';
import AcessoRapido from '@/components/home/acessoRapido/AcessoRapido';

import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

import { mapState } from 'vuex';

export default {
    name: 'index',

    components: {
        AcessoRapido,
        PesquisaInteligente,
        PesquisaInteligenteParaguay,
        PesquisaInteligenteArgentina,
        CentralAlerta,
        Totalizadores,
        CentralEventos,
        BannerNoticias
    },

    data() {
        return {
            ambientes: AmbientesEmpresas
        };
    },

    computed: {
        ...mapState(['usuarioLogado'])
    }
};
</script>

<style lang="scss" scoped>
.home {
    padding: 20px;
    height: 100%;
    display: grid;
    gap: 12px;
    grid-template:
        'pesquisa-inteligente pesquisa-inteligente' 50px
        'noticias central-alertas' 200px
        'acesso-rapido central-eventos' 140px
        'totalizadores central-eventos' 1fr/2fr 1fr;
}

.home__pesquisa-inteligente {
    grid-area: pesquisa-inteligente;
}

.home__noticias {
    grid-area: noticias;
    padding-bottom: 30px;
}

.home__central-alertas {
    grid-area: central-alertas;
    padding-bottom: 30px;
}

.home__acesso-rapido {
    grid-area: acesso-rapido;
    overflow-x: auto;
    overflow-y: hidden;
}

.home__totalizadores {
    grid-area: totalizadores;
}

.home__central-eventos {
    grid-area: central-eventos;
}
</style>
